import { useMutation, useQueryClient } from '@tanstack/react-query'
import { addExclusion } from 'api/wage/addExclusion'
import { wageRuleKeys } from './keys'

export const useAddExclusionMutation = (ruleId: number) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (request: Parameters<typeof addExclusion>[0]) =>
      addExclusion(request),
    onSuccess: () => {
      return queryClient.invalidateQueries({
        queryKey: wageRuleKeys.byId(ruleId),
      })
    },
  })
}
